/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';
import { FSF_BRAND } from '../fsfPages.generated';
import ContactIcon from '../components/ContactIcon';
import { CONTACT_DETAILS, CONTACT_MAP_EMBED_URL, CONTACT_MAP_URL, CONTACT_QUOTE_IMAGE } from '../data/siteData';

export function ContactDetailCard({ detail }) {
  const content = detail.lines ? (
    detail.lines.map((line) => <span key={line}>{line}</span>)
  ) : (
    <span>{detail.value}</span>
  );

  return (
    <article className="fsf-contact-card">
      <div className="fsf-contact-card__icon">
        <ContactIcon name={detail.icon} />
      </div>
      <div className="fsf-contact-card__body">
        <h3>{detail.label}</h3>
        {detail.href ? (
          <a href={detail.href} target={detail.href.startsWith('http') ? '_blank' : undefined} rel={detail.href.startsWith('http') ? 'noopener noreferrer' : undefined}>
            {content}
          </a>
        ) : (
          <p>{content}</p>
        )}
      </div>
    </article>
  );
}

export default function ContactPageSections() {
  return (
    <div className="fsf-contact">
      <section className="fsf-contact-map" aria-label="Freight Services Fiji map">
        <iframe
          title="Freight Services Fiji on Google Maps"
          src={CONTACT_MAP_EMBED_URL}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
        <a className="fsf-contact-map__link" href={CONTACT_MAP_URL} target="_blank" rel="noopener noreferrer">
          Open in Maps
          <ContactIcon name="external" />
        </a>
      </section>

      <section className="fsf-contact-layout" aria-label="Freight Services Fiji contact details">
        <div className="fsf-contact-panel">
          <p className="fsf-section-kicker">General Enquiry</p>
          <h2>Talk to the FSF team</h2>
          <p>
            Reach out for freight forwarding, shipping, storage, moving, relocation, and branch support.
            We will help route your enquiry to the right team.
          </p>

          <div className="fsf-contact-grid">
            {CONTACT_DETAILS.map((detail) => (
              <ContactDetailCard key={detail.label} detail={detail} />
            ))}
          </div>
        </div>

        <aside className="fsf-contact-quote" aria-label="Quotation request">
          <div className="fsf-contact-quote__copy">
            <p className="fsf-section-kicker">Need a quotation?</p>
            <h2>Start your quote request online</h2>
            <p>Scan the QR code from your mobile device or open the form directly.</p>
          </div>
          <a className="fsf-contact-quote__image" href={FSF_BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
            <img src={CONTACT_QUOTE_IMAGE} alt="Need a quotation QR code" loading="lazy" />
          </a>
          <a className="fsf-button fsf-contact-quote__button" href={FSF_BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
            Start Quote
          </a>
        </aside>
      </section>
    </div>
  );
}
